export default __webpack_public_path__ + "static/media/Connexion.b61bfc06.png";